import { cn } from "@/lib/utils";

export default function Tag({ label, className }: { label: string; className?: string }) {
    return (
        <span
            className={cn(
                "text-[12px] rounded-[4px] text-textSecondary py-2 px-3 bg-bg",
                className
            )}
        >
            {label}
        </span>
    );
}
